import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'subscriptionStatus',
  standalone: false,
})
export class SubscriptionStatusPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: unknown): string {
    return (
      this.translate.instant(`enums.subscriptionStatus.${value}`) ||
      this.translate.instant('common.unknown')
    );
  }
}
